import { render, staticRenderFns } from "./PortCall.vue?vue&type=template&id=29ac6071&scoped=true"
import script from "./PortCall.vue?vue&type=script&lang=js"
export * from "./PortCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac6071",
  null
  
)

export default component.exports